import { inject } from '@angular/core';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { CanActivateFn } from '@angular/router';
import { SecurityManager } from '../services/security.manager';
import { Router } from '@angular/router';

export const organizationGuard: CanActivateFn = () => {
    const securityManager = inject(SecurityManager);
    const router = inject(Router);

    if (!securityManager.hasOrganization()) {
        return router.createUrlTree([APP_ROUTES.accessForbidden]);
    }

    if (!securityManager.getCurrentOrganization()) {
        return router.createUrlTree([APP_ROUTES.selectOrganization]);
    }

    return true;
};
